import { render } from "./verification-methods.vue?vue&type=template&id=22d2e841&scoped=true"
import script from "./verification-methods.vue?vue&type=script&lang=js"
export * from "./verification-methods.vue?vue&type=script&lang=js"

import "./verification-methods.vue?vue&type=style&index=0&id=22d2e841&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22d2e841"]])

export default __exports__